import { useTranslation } from "@/hooks";
import { generateUniqueKeys } from "@/utils/keys";
import {
	Card,
	CardContent,
	CardHeader,
	Skeleton,
	Typography,
} from "@st-marketplace/ui";

const OrderDetailsInfoSkeleton = () => {
	const rowCount = 10;
	const { t } = useTranslation();

	return (
		<>
			<div className="mb-6 flex items-center justify-between">
				<div className="mb-2">
					<Typography variant="title-md" as="h1" className="mb-2">
						{t("orderInfo.title")}
					</Typography>
					<Skeleton className="h-8 w-40" />
				</div>
				<Card className="rounded-md">
					<Skeleton className="size-8 rounded-md" />
				</Card>
			</div>

			<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
				<Card>
					<CardHeader>
						<div className="flex items-center gap-3">
							<Skeleton className="size-9 rounded-full" />
							<Skeleton className="h-6 w-38" />
						</div>
					</CardHeader>
					<CardContent className="flex flex-col gap-5">
						{generateUniqueKeys(rowCount).map((key) => (
							<div key={key} className="flex">
								<div className="h-5 w-[35%]">
									<Skeleton className="h-5 w-1/2" />
								</div>
								<div className="h-5 w-[65%]">
									<Skeleton className="h-5 w-full" />
								</div>
							</div>
						))}
					</CardContent>
				</Card>

				<Card className="h-full">
					<CardHeader>
						<div className="flex items-center gap-3">
							<Skeleton className="size-9 rounded-full" />
							<Skeleton className="h-6 w-45" />
						</div>
					</CardHeader>
					<CardContent className="flex flex-col gap-5">
						{generateUniqueKeys(7).map((key) => (
							<div key={key} className="flex items-center justify-between">
								<Skeleton className="h-8 w-25 rounded-md" />
								<Skeleton className="h-5 w-30" />
							</div>
						))}
					</CardContent>
				</Card>

				<Card className="col-span-1 md:col-span-2">
					<CardHeader>
						<div className="flex items-center gap-3">
							<Skeleton className="size-9 rounded-full" />
							<Skeleton className="h-6 w-40" />
						</div>
					</CardHeader>
				</Card>
			</div>
		</>
	);
};

export default OrderDetailsInfoSkeleton;
